import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Send } from 'lucide-react';
import PageHeader from './PageHeader';
import SpotlightCard from './SpotlightCard';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Contato pelo site - ${formData.name}`);
    const body = encodeURIComponent([
      `Nome: ${formData.name}`,
      `Email: ${formData.email}`,
      `Telefone: ${formData.phone || 'Não informado'}`,
      `Empresa: ${formData.company || 'Não informada'}`,
      '',
      formData.message
    ].join('\n'));

    window.location.href = `mailto:ricardo.tadel@sditi.com.br?subject=${subject}&body=${body}`;
  };

  const contactInfo = [
    {
      icon: Phone,
      title: 'Telefone',
      info: '11 96415-8980',
      description: 'Segunda a Sexta, 8h às 18h'
    },
    {
      icon: Mail,
      title: 'Email',
      info: 'contato.site@sditi.com.br',
      description: 'Respondemos em até 24h'
    },
    {
      icon: MapPin,
      title: 'Endereço',
      info: 'Escritórios em SP / RJ e SC',
      description: 'Brasil'
    }
  ];

  return (
    <>
      <PageHeader
        title="Fale Conosco"
        subtitle="Pronto para transformar seu negócio? Conte com nossa expertise para impulsionar sua empresa com tecnologia de ponta."
        breadcrumb="Contato"
      />

      <section className="contact section">
        <div className="container">
          <div className="contact-content">
            <div className="contact-info">
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
              >
                <h3>Vamos conversar?</h3>
                <p>
                  Nossa equipe está pronta para entender suas necessidades e apresentar as melhores soluções para seu negócio.
                </p>

                <div className="contact-methods">
                  {contactInfo.map((item, index) => (
                    <SpotlightCard key={index} className="contact-method-card" spotlightColor="rgba(220, 38, 38, 0.05)">
                      <div className="contact-method-inner">
                        <div className="contact-icon-wrapper">
                          <item.icon size={24} strokeWidth={1.5} />
                        </div>
                        <div className="contact-details">
                          <h4 className="contact-title">{item.title}</h4>
                          <p className="contact-info-text">{item.info}</p>
                          <p className="contact-description">{item.description}</p>
                        </div>
                      </div>
                    </SpotlightCard>
                  ))}
                </div>
              </motion.div>
            </div>

            <motion.div
              className="contact-form-container"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <SpotlightCard className="h-full" spotlightColor="rgba(0,0,0,0.03)">
                <div className="p-8">
                  <form className="contact-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                      <label htmlFor="name">Nome Completo *</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="Seu nome completo"
                        className="form-input"
                      />
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="email">Email *</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          placeholder="seu@email.com"
                          className="form-input"
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="phone">Telefone</label>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          placeholder="(11) 99999-9999"
                          className="form-input"
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label htmlFor="company">Empresa</label>
                      <input
                        type="text"
                        id="company"
                        name="company"
                        value={formData.company}
                        onChange={handleChange}
                        placeholder="Nome da sua empresa"
                        className="form-input"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="message">Mensagem *</label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        rows="5"
                        placeholder="Conte-nos sobre seu projeto ou necessidade..."
                        className="form-input"
                      ></textarea>
                    </div>

                    <p className="form-helper">
                      Ao continuar, seu aplicativo de e-mail será aberto com a mensagem pronta para revisão e envio.
                    </p>
                    <button type="submit" className="btn contact-submit-button">
                      <span>Preparar E-mail</span>
                      <Send size={19} aria-hidden="true" />
                    </button>
                  </form>
                </div>
              </SpotlightCard>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
